import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.5",
      fill: "#F5FAFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4 4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M20.667 13.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M20.667 14.333c-1.654 0-3-1.346-3-3 0-.48.126-.926.326-1.333h-4.98c-2.3 0-3.68 1.373-3.68 3.68v5.3c0 2.313 1.38 3.687 3.68 3.687h5.3c2.307 0 3.68-1.374 3.68-3.68v-4.98c-.4.2-.846.326-1.326.326",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M15.833 17.333H12.5a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h3.333c.274 0 .5.227.5.5 0 .274-.226.5-.5.5M18.5 20h-6a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h6c.273 0 .5.227.5.5s-.227.5-.5.5"
    }, null, -1)
  ]))]))
}
export default { render: render }